import Vue from 'vue'

export default ({ app }) => {
  Vue.use({
    install(vue) {
      vue.prototype.$locale = app.i18n.locale
    },
  })
}
